<template>
  <div class="m-targetSet">
    <a-spin :spinning="targetSpinning" class="spin-target" size="large" />
    <div v-if="is_show_spaceId == 2 || is_show_spaceId == 3">
      <div class="u-modle-p">受众类型</div>
      <div class="option-wrap">
        <p>
          <span>性别：</span>
          <a-checkbox-group
            :options="sexOptions"
            v-model="sexValue"
            @change="changeCondition"
          />
        </p>
        <br />
        <p>
          <span>年龄：</span>
          <a-checkbox-group
            :options="ageOptions"
            v-model="ageValue"
            @change="changeCondition"
          />
        </p>
      </div>
    </div>
    <choose-point
      ref="choosePoint"
      :getAreaDataList="getAreaDataList"
      :deliveryPeriodConfig="deliveryPeriodConfig"
    />
    <a-form class="m-form" :form="form">
      <div>
        <div class="select-wrap">
          <div class="select-box">
            <div
              class="row"
              :style="{ maxHeight: showMoreProvinceBtn ? '48px' : '200px' }"
            >
              <span class="title">省份：</span>
              <ul class="option-ul">
                <li
                  @click="unlimitedSelect('provinces')"
                  :class="provinceActive.length == 0 ? 'active' : ''"
                >
                  不限
                </li>
                <li
                  @click="handleChoose('province', item, item.areaCode)"
                  v-for="(item, index) in provincesArr"
                  :key="index"
                  v-if="item"
                  :class="
                    provinceActive.indexOf(item.areaCode) != -1 ? 'active' : ''
                  "
                >
                  {{ item.areaName }}
                </li>
              </ul>
              <div v-if="provincesArr.length > rowMaxLength">
                <p
                  v-if="showMoreProvinceBtn"
                  @click="showMoreProvinceBtn = false"
                >
                  更多
                  <a-icon type="down" />
                </p>
                <p v-else @click="showMoreProvinceBtn = true">
                  收起
                  <a-icon type="up" />
                </p>
              </div>
            </div>
            <div
              class="row"
              :style="{ maxHeight: showMoreCityBtn ? '48px' : '200px' }"
            >
              <span class="title">城市：</span>
              <ul class="option-ul">
                <li
                  @click="unlimitedSelect('city')"
                  :class="cityActive.length == 0 ? 'active' : ''"
                >
                  不限
                </li>
                <li
                  @click="handleChoose('city', item, item.areaCode)"
                  v-for="(item, index) in cityArr"
                  :key="index"
                  :class="
                    cityActive.indexOf(item.areaCode) != -1 ? 'active' : ''
                  "
                >
                  {{ item.areaName }}
                </li>
              </ul>
              <div v-if="cityArr.length > rowMaxLength">
                <p v-if="showMoreCityBtn" @click="showMoreCityBtn = false">
                  更多
                  <a-icon type="down" />
                </p>
                <p v-else @click="showMoreCityBtn = true">
                  收起
                  <a-icon type="up" />
                </p>
              </div>
            </div>
            <div class="row">
              <span class="title">区县：</span>
              <ul class="option-ul">
                <li
                  @click="unlimitedSelect('area')"
                  :class="areaActive.length == 0 ? 'active' : ''"
                >
                  不限
                </li>
                <li
                  @click="handleChoose('area', item, item.areaCode)"
                  v-for="(item, index) in areaArr"
                  :key="index"
                  :class="
                    areaActive.indexOf(item.areaCode) != -1 ? 'active' : ''
                  "
                >
                  {{ item.areaName }}
                </li>
              </ul>
            </div>
            <div class="row">
              <span class="title">设备：</span>
              <ul class="option-ul">
                <li
                  @click="unlimitedSelect('machine')"
                  :class="machineActive.length == 0 ? 'active' : ''"
                >
                  不限
                </li>
                <li
                  @click="handleChoose('machine', item, item.deviceModel)"
                  v-for="(item, index) in machineArr"
                  :key="index"
                  :class="
                    machineActive.indexOf(item.deviceModel) != -1
                      ? 'active'
                      : ''
                  "
                >
                  {{ item.deviceModelText }}
                </li>
              </ul>
              <p
                style="
                  background: #fff;
                  color: #1890ff;
                  cursor: pointer;
                  font-size: 14px;
                "
                @click="showModel = true"
              >
                查看型号
              </p>
            </div>
            <div class="row">
              <span class="lineOn">连续在线：</span>
              <ul class="option-ul">
                <li
                  @click="unlimitedSelect('day')"
                  :class="dayColor == -1 ? 'active' : ''"
                >
                  不限
                </li>
                <li
                  v-for="(item, index) in onLineDasy"
                  :key="index"
                  @click="handleChoose('day', item)"
                  :class="dayColor == index ? 'active' : ''"
                >
                  连续在线>{{ item }}天
                </li>
              </ul>
            </div>
            <div class="row other" style="overflow:visible">
              <span class="title">其他：</span>
              <span
                class="other-select-menu"
                :class="tagIds.length > 0 ? 'active' : ''"
              >
                标签
              </span>
              <MultipleCascder
                class="multiple-cascder"
                :value="tagIds"
                :allowClear="false"
                placeholder="标签"
                :selectOptionsConfig="{
                  key: 'id',
                  value: 'id',
                  text: 'name',
                  children: 'children',
                  disabled: 'status'
                }"
                allText=""
                noDataText="暂无数据"
                :treeData="tagsTree"
                @change="changeTags"
                :maxTagCount="0"
                :maxTagTextLength="5"
                :hasTab="true"
                :tabsValue.sync="tabsValue"
                ref="multipleCascderRef"
              />
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="buildTypeVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="buildTypeActive !== '' ? 'active' : ''"
                  >
                    楼盘类型
                  </span>
                  <template slot="content">
                    <ul class="tag-ul">
                      <li
                        class="tag-li"
                        v-for="(item, index) in buildTypeArr"
                        :key="index"
                        :class="buildTypeActive == item.name ? 'active' : ''"
                        @click="otherChoose(item)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </template>
                </a-popover>
              </div>
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="houseNumVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="houseNumActive ? 'active' : ''"
                  >
                    住户数
                  </span>
                  <template slot="content">
                    <div class="range-input">
                      <div class="inputs">
                        <a-input placeholder="" v-model="houseNumMin" />
                        <span>-</span>
                        <a-input placeholder="" v-model="houseNumMax" />
                      </div>
                      <div class="btns">
                        <a-button @click="clearTagsInput('houseNum')"
                          >清除</a-button
                        >
                        <a-button
                          type="primary"
                          @click="tagsInputConfirm('houseNum')"
                          >确定
                        </a-button>
                      </div>
                    </div>
                  </template>
                </a-popover>
              </div>
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="buildPriceVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="buildPriceActive ? 'active' : ''"
                  >
                    楼盘价格
                  </span>
                  <template slot="content">
                    <div class="range-input">
                      <div class="inputs">
                        <a-input placeholder="" v-model="buildPriceMin" />
                        <span>-</span>
                        <a-input placeholder="" v-model="buildPriceMax" />
                      </div>
                      <div class="btns">
                        <a-button @click="clearTagsInput('buildPrice')"
                          >清除</a-button
                        >
                        <a-button
                          type="primary"
                          @click="tagsInputConfirm('buildPrice')"
                          >确定
                        </a-button>
                      </div>
                    </div>
                  </template>
                </a-popover>
              </div>
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="personVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="personActive ? 'active' : ''"
                  >
                    人流量
                  </span>
                  <template slot="content">
                    <div class="range-input">
                      <div class="inputs">
                        <a-input placeholder="" v-model="personMin" />
                        <span>-</span>
                        <a-input placeholder="" v-model="personMax" />
                      </div>
                      <div class="btns">
                        <a-button @click="clearTagsInput('person')"
                          >清除</a-button
                        >
                        <a-button
                          type="primary"
                          @click="tagsInputConfirm('person')"
                          >确定
                        </a-button>
                      </div>
                    </div>
                  </template>
                </a-popover>
              </div>
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="yearsVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="yearsActive !== '' ? 'active' : ''"
                  >
                    入住年份
                  </span>
                  <template slot="content">
                    <ul class="tag-ul">
                      <li
                        class="tag-li"
                        v-for="(item, index) in yearsArr"
                        :key="index"
                        :class="yearsActive == item.id ? 'active' : ''"
                        @click="otherChoose(item)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </template>
                </a-popover>
              </div>
              <div>
                <a-popover
                  trigger="click"
                  placement="bottomLeft"
                  overlayClassName="other-pop"
                  v-model="excludeVisible"
                >
                  <span
                    class="other-select-menu"
                    :class="excludeActive !== '' ? 'active' : ''"
                  >
                    排除同行
                  </span>
                  <template slot="content">
                    <ul class="tag-ul">
                      <li
                        class="tag-li"
                        v-for="(item, index) in excludeTypeArr"
                        :key="index"
                        :class="excludeActive == item.name ? 'active' : ''"
                        @click="otherChoose(item)"
                      >
                        {{ item.name }}
                      </li>
                    </ul>
                  </template>
                </a-popover>
              </div>
            </div>
          </div>
          <div class="tags-box" v-if="tags.length > 0">
            <div class="tag" v-for="(item, index) in tags" :key="index">
              <span v-if="item.type != 'tag'"> {{ item.name }}</span>
              <span v-else> {{ isIncludeStr + item.name }}</span>

              <a-icon type="close" @click="deleteTag(item, index)" />
            </div>
            <span class="all-clear" @click="clearTags">清空条件</span>
          </div>
          <div class="tip-box">
            <a-alert showIcon type="info">
              <template>
                <div slot="message" class="content-line">
                  为您找到
                  <span>{{ total }}</span> 个可投点位，已勾选
                  <span>{{ selectedList ? selectedList.length : 0 }}</span>
                  个点位
                  <div class="action-line">
                    <span @click="showFastModel">一键选点</span>
                    <div
                      style="
                        width: 1px;
                        height: 14px;
                        margin: 0 12px;
                        background-color: #00000033;
                      "
                    ></div>
                    <span @click="setMapParams">地图选点</span>
                  </div>
                </div>
              </template>
            </a-alert>
          </div>
          <div class="table-box">
            <a-table
              row-key="id"
              v-sliceSourceData="scrollUpdateTableSource"
              :pagination="false"
              :scroll="{ x: 1900, y: 555 }"
              :loading="scrollTableLoading"
              :dataSource="scrollAreaDataList"
              :columns="areaDataListColumns"
              :rowSelection="{
                onSelect: areaSelectOne,
                onSelectAll: areaSelectAll,
                selectedRowKeys: areaDataListRow
              }"
              @change="changeList"
            >
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column
                }"
                class="custom-filter-dropdown"
              >
                <a-input
                  v-ant-ref="c => (searchInput = c)"
                  :placeholder="`搜索${column.title}`"
                  :value="selectedKeys[0]"
                  @change="
                    e => setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  >搜索
                </a-button>
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                  >重置
                </a-button>
              </div>
              <template slot="deviceName" slot-scope="deviceName">
                <p>{{ deviceName || "--" }}</p>
              </template>
              <template slot="onlineStatus" slot-scope="onlineStatus">
                <p>
                  {{
                    onlineStatus == 0
                      ? "设备离线"
                      : onlineStatus == 1
                      ? "设备在线"
                      : onlineStatus == 2
                      ? "离线超时"
                      : ""
                  }}
                </p>
              </template>
              <template slot="buildType" slot-scope="buildType">
                <p>{{ buildType || "--" }}</p>
              </template>
              <template slot="residentCount" slot-scope="residentCount">
                <p>{{ residentCount || "--" }}</p>
              </template>
              <template slot="buildType" slot-scope="buildType">
                <p>{{ buildType || "--" }}</p>
              </template>
              <template slot="buildPrice" slot-scope="buildPrice">
                <p>{{ buildPrice | NumberFormat }}</p>
              </template>
              <template slot="buildCount" slot-scope="buildCount">
                <p>{{ buildCount || "--" }}</p>
              </template>
              <template slot="moveInYear" slot-scope="moveInYear">
                <p>{{ moveInYear || "--" }}</p>
              </template>
              <template slot="humanTraffic" slot-scope="humanTraffic">
                <p>{{ humanTraffic || "--" }}</p>
              </template>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
            </a-table>
          </div>
          <div class="page-wrap">
            <a-pagination
              :pageSizeOptions="pageSizeOptions"
              :total="total"
              showSizeChanger
              showQuickJumper
              :pageSize="pageSize"
              v-model="current"
              @showSizeChange="onShowSizeChange"
              @change="changePage"
            >
            </a-pagination>
          </div>
        </div>
      </div>
    </a-form>
    <a-alert
      class="warn-box"
      message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！"
      type="warning"
      show-icon
    />
    <a-affix :offsetBottom="0">
      <div class="m-foot-btn">
        <a-button @click="lastStep">上一步</a-button>
        <a-button
          class="u-nextStep-btn"
          type="primary"
          @click="nextStep"
          :loading="valiateLoading"
          >下一步</a-button
        >
        <a-button class="u-nextStep-btn" type="default" @click="saveDraft"
          >存为草稿</a-button
        >
        <a-badge
          :count="selectedList ? selectedList.length : 0"
          :overflowCount="99999"
        >
          <a-button type="primary" @click="selectedModel = true"
            >已选点位</a-button
          >
        </a-badge>
      </div>
    </a-affix>
    <!--查看型号-->
    <a-modal title="查看型号" v-model="showModel" width="872px">
      <div>
        <a-tabs class="model-tabs" defaultActiveKey="1" tabPosition="left">
          <a-tab-pane tab="QLG19-215&C215" key="1">
            <img
              style="width: 264px"
              src="../../assets/images/QLG19-215&C215@2x.png"
            />
          </a-tab-pane>
          <a-tab-pane tab="QLL19-32&C32" key="2">
            <img
              style="width: 264px"
              src="../../assets/images/QLL19-32&C32@2x.png"
            />
          </a-tab-pane>
          <a-tab-pane tab="GWS19-49" key="3">
            <img
              style="width: 485px; margin-top: 142px"
              src="../../assets/images/GWS19-49@2x.png"
            />
          </a-tab-pane>
        </a-tabs>
      </div>
      <template slot="footer">
        <a-button @click="showModel = false">关闭</a-button>
      </template>
    </a-modal>
    <!--已选点位-->
    <a-modal title="已选点位" v-model="selectedModel" width="1064px">
      <div class="selected-wrap">
        <template>
          <a-table
            :loading="selectedListloading"
            :dataSource="selectedList"
            :columns="selectedColumns"
            :rowSelection="{
              selectedRowKeys: selectedListRow,
              onChange: changeSelected
            }"
            row-key="id"
            :scroll="{ y: 555 }"
            @change="changeSelectedList"
          >
            <div
              slot="filterDropdown"
              slot-scope="{
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
                column
              }"
              class="custom-filter-dropdown"
            >
              <a-input
                v-ant-ref="c => (selectSearchInput = c)"
                :placeholder="`搜索${column.title}`"
                :value="selectedKeys[0]"
                @change="
                  e => setSelectedKeys(e.target.value ? [e.target.value] : [])
                "
                @pressEnter="() => handleSearch(selectedKeys, confirm)"
                style="width: 188px; margin-bottom: 8px; display: block"
              />
              <a-button
                type="primary"
                @click="() => handleSearchSelected(selectedKeys, confirm)"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                >搜索
              </a-button>
              <a-button
                @click="() => handleResetSelected(clearFilters)"
                size="small"
                style="width: 90px"
                >重置
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="action" slot-scope="row">
              <a href="javascript:" @click="delectSelected(row)">删除</a>
            </template>
            <template slot="onlineStatus" slot-scope="onlineStatus">
              <p>
                {{
                  onlineStatus == 0
                    ? "设备离线"
                    : onlineStatus == 1
                    ? "设备在线"
                    : onlineStatus == 2
                    ? "离线超时"
                    : ""
                }}
              </p>
            </template>
          </a-table>
        </template>
        <a-button class="delect-btn" @click="delectSelectedFast"
          >删除所选</a-button
        >
      </div>
      <template slot="footer">
        <a-button @click="delectSelectedAll">清空</a-button>
        <a-button @click="exportPoint">导出点位</a-button>
        <a-button @click="selectedModel = false">关闭</a-button>
      </template>
    </a-modal>
    <!--一键选点-->
    <a-modal
      title="一键选点"
      v-model="fastSelectModel"
      width="646px"
      :maskClosable="false"
      @cancel="closeFastModel"
    >
      <div class="fast-model">
        <a-alert showIcon type="info">
          <template>
            <p slot="message">
              当前最多可投点位
              <span style="color: #1890ff">{{ total }}</span> 个
            </p>
          </template>
        </a-alert>
        <div class="inputs">
          <a-input
            :class="countInputErr ? 'error-fast-count-input' : ''"
            style="width: 160px"
            placeholder="投放总量"
            v-model="fastInfo.doorNum"
            @blur="checkCountInput"
          />
          <div>
            <a-select
              v-model="fastInfo.areaType"
              style="width: 120px"
              @change="changeFastArea"
            >
              <a-select-option value="0">每个城市</a-select-option>
              <a-select-option value="1">每个区/县</a-select-option>
              <a-select-option value="2">每个小区</a-select-option>
            </a-select>
            <a-select v-model="fastInfo.compareType" style="width: 120px">
              <a-select-option value="1">等于</a-select-option>
            </a-select>
            <a-input
              @blur="checkCountInput2"
              :class="countInputErr2 ? 'error-fast-count-input' : ''"
              style="width: 140px"
              placeholder="请输入数量"
              v-model="fastInfo.count"
            />
          </div>
          <a-button
            type="primary"
            @click="handleFastSearch"
            :loading="fastBtnLoading"
            >查找</a-button
          >
        </div>
        <p
          v-if="showfastRestultTip && fastInfo.doorNum == fastResult.length"
          style="color: #1890ff"
        >
          满足的点位
          {{ fastResult.length }}
          个，可重新调整查找条件，或选择“确定”直接添加到已选点位
        </p>
        <p v-else-if="showfastRestultTip">
          满足的点位
          {{ fastResult.length }}
          个，可重新调整查找条件，或选择“确定”直接添加到已选点位
        </p>
      </div>
      <template slot="footer">
        <a-button
          :style="{ display: showFastFooter ? '' : 'none' }"
          @click="closeFastModel"
          >取消</a-button
        >
        <a-button
          type="primary"
          :style="{ display: showFastFooter ? '' : 'none' }"
          @click="handleFastAction"
          >确定
        </a-button>
      </template>
    </a-modal>
    <discontent-points-modal
      ref="discontentModal"
      :dataSource="selectedList"
      :valiateAdMachineShareData="valiateAdMachineShareData"
    />
    <!--销售收入确认弹框-->
    <a-modal
      v-model="saleIncomeModal"
      title="销售收入确认"
      width="900px"
      @ok="handleSaleIncome"
    >
      <a-table
        :columns="columnSaleIncome"
        :data-source="tableDataSaleIncome"
        :pagination="false"
      >
        <template slot="publicationPrice">
          <li>518元/周</li>
        </template>
        <template slot="pointCount" slot-scope="count">
          <li v-for="(item, index) in count" :key="index">{{ item }}</li>
        </template>
        <template slot="demand" slot-scope="demand">
          <li>{{ demand }}</li>
        </template>
        <template slot="saleIncomeCell">
          <a-input-number :min="0" v-model="income" />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { TreeSelect } from "ant-design-vue";
import { api } from "../../commomFun/api";
import { cacheDrafts } from "../../commomFun/cacheApi";
import timeFormat from "../../commomFun/timeFormat";
import moment from "moment";
import choosePoint from "./choosePoint";
import discontentPointsModal from "./discontentPointsModal";
//之前都是使用本地配置秒数和次数，这次更改使用后端数据。前端逻辑不做修改，将后端数据更改为前端需要数据格式
import { getDeliveryPeriodConfig } from "../../commomFun/deliveryPeriodConfig";
import { mapState } from "vuex";
import MultipleCascder from "../common/MultipleCascder.vue";

const SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  components: {
    choosePoint,
    discontentPointsModal,
    MultipleCascder
  },
  data() {
    return {
      targetSpinning: false,
      scrollTableLoading: false,
      // 当前步骤
      step: 1,
      valiateAdMachineShareData: {},
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 }
      },
      value: undefined,
      SHOW_PARENT,
      isShow: false,
      formItem: {},
      areaNum: 0,
      cNum: 0,
      sexOptions: [{ label: "男", value: "1" }, { label: "女", value: "2" }],
      sexValue: [],
      ageOptions: [
        { label: "17岁以下", value: "1" },
        { label: "18岁~24岁", value: "2" },
        { label: "25岁~29岁", value: "3" },
        { label: "30岁~39岁", value: "4" },
        { label: "40岁~49岁", value: "5" },
        { label: "50岁~64岁", value: "6" },
        { label: "65岁以上", value: "7" }
      ],
      ageValue: [],
      // 机型获取中
      modelSpinning: true,
      // 机型数据
      typeInfos: [],
      selectModelIDs: [],
      // 机型list
      modelInfoList: [],
      // 请选择广告机型弹出框
      // isAddModelModal: false,
      // 当前选择的机型
      activeModelID: true,
      checkboxModel: true,
      isModelID: "",
      editPlanId: "",
      checkNodes: [],
      //区域范围相关选择
      showMoreProvinceBtn: true, //更多
      showMoreCityBtn: true, //更多
      pageSizeOptions: ["10", "20", "50", "100", "500", "1000"],
      current: 1,
      pageSize: 10,
      total: 0,
      provincesArr: [], //省份
      cityArr: [], //城市
      areaArr: [], //区县
      machineArr: [], //设备
      onLineDasy: [3, 7, 15, 30], //在线天数
      provinceActive: [],
      cityActive: [],
      areaActive: [],
      machineActive: [],
      conditionList: [],
      //其他
      buildTypeVisible: false,
      houseNumVisible: false,
      buildPriceVisible: false,
      personVisible: false,
      yearsVisible: false,
      excludeVisible: false,
      buildTypeArr: [
        { name: "高端住宅", id: 1, type: "buildType" },
        { name: "中端住宅", id: 2, type: "buildType" },
        { name: "普通住宅", id: 3, type: "buildType" },
        { name: "单体楼", id: 4, type: "buildType" },
        { name: "别墅", id: 5, type: "buildType" },
        { name: "洋房", id: 6, type: "buildType" },
        { name: "商住型写字楼", id: 7, type: "buildType" }
      ], //楼盘类型
      buildTypeActive: "",
      watchMode: [],
      yearsArr: [], //入住年份
      yearsActive: "",
      houseNumMin: "",
      houseNumMax: "", //住户数区间
      houseNumActive: false,
      buildPriceMin: "",
      buildPriceMax: "", //楼盘价格区间
      buildPriceActive: false,
      personMin: "",
      personMax: "", //人流量区间
      personActive: false,
      excludeActive: "",
      excludeTypeArr: [
        { name: "排除小区", id: 1, type: "excludeType" },
        { name: "排除点位", id: 2, type: "excludeType" }
      ],
      tags: [],
      //筛选出来的区域列表
      areaDataListColumns: [
        {
          title: "点位名称",
          key: "deviceName",
          dataIndex: "deviceName",
          fixed: "left",
          width: 200,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "deviceName"
          }
        },
        {
          title: "网络状态",
          dataIndex: "onlineStatus",
          key: "onlineStatus",
          width: 120,
          scopedSlots: { customRender: "onlineStatus" },
          filters: [
            { text: "全部", value: "" },
            { text: "设备在线", value: "1" },
            { text: "设备离线", value: "0" },
            { text: "离线超时", value: "2" }
          ],
          filteredValue: [""],
          filterMultiple: false
        },

        {
          title: "终端型号",
          dataIndex: "deviceModelText",
          key: "deviceModelText",
          width: 120,
          scopedSlots: { customRender: "deviceModelText" }
        },
        {
          title: "监播方式",
          key: "watchModeName",
          align: "left",
          width: 142,
          ellipsis: true,
          filters: [
            { text: "程序截屏", value: "1" },
            { text: "人工拍照", value: "2" }
          ],
          filterMultiple: true,
          customRender: (text, record) => (record.watchModeName || []).join(";")
        },
        {
          title: "Mac",
          dataIndex: "mac",
          key: "mac",
          ellipsis: true,
          width: 150,
          scopedSlots: {
            customRender: "mac",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          }
        },
        {
          title: "广告尺寸",
          dataIndex: "size",
          key: "size",
          width: 120
        },
        {
          // title: '小区名称',
          title: "网点资源",
          key: "communityName",
          dataIndex: "communityName",
          ellipsis: true,
          width: 160,
          scopedSlots: {
            customRender: "communityName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          }
        },
        {
          title: "区县",
          dataIndex: "areaName",
          key: "areaName",
          width: 120
        },
        {
          title: "城市",
          dataIndex: "cityName",
          key: "cityName",
          width: 120
        },
        {
          title: "省份",
          dataIndex: "provinceName",
          key: "provinceName",
          width: 120
        },
        {
          title: "连续在线",
          dataIndex: "onlineDayNum",
          key: "onlineDayNum",
          width: 120,
          scopedSlots: { customRender: "onlineDayNum" },
          sorter: true,
          align: "center"
        },
        {
          title: "楼盘类型",
          dataIndex: "buildType",
          key: "buildType",
          width: 120,
          scopedSlots: { customRender: "buildType" }
        },
        {
          title: "住户数",
          dataIndex: "residentCount",
          key: "residentCount",
          width: 100,
          scopedSlots: { customRender: "residentCount" },
          sorter: true
        },
        {
          title: "楼盘价格",
          dataIndex: "buildPrice",
          key: "buildPrice",
          width: 120,
          scopedSlots: { customRender: "buildPrice" },
          sorter: true
        },
        {
          title: "楼栋数量",
          dataIndex: "buildCount",
          key: "buildCount",
          width: 120,
          scopedSlots: { customRender: "buildCount" }
        },
        {
          title: "入住年份",
          dataIndex: "moveInYear",
          key: "moveInYear",
          width: 120,
          scopedSlots: { customRender: "moveInYear" }
        },
        {
          title: "人流量",
          dataIndex: "humanTraffic",
          key: "humanTraffic",
          width: 115,
          scopedSlots: { customRender: "humanTraffic" },
          sorter: true
        }
      ],
      areaDataList: [],
      tableDataCursor: 20,
      searchInput: null, //列表搜索框
      areaDataListRow: [], //待选列表选中的列Key值
      showModel: false, //查看型号模态框
      //已选点位
      searchText: "",
      selectSearchText: "",
      selectedListloading: false,
      selectedModel: false,
      searchInputSelected: null,
      selectedListRow: [], //已选列表选中的列Key值
      selectedColumns: [
        {
          title: "省份-城市-区县",
          key: "areaString",
          dataIndex: "areaString",
          width: 220,
          ellipsis: true,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) => record.areaString.includes(value),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                // this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "网点资源",
          key: "communityName",
          dataIndex: "communityName",
          width: 150,
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) => record.communityName.includes(value),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                // this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "点位名称",
          key: "deviceName",
          width: 120,
          ellipsis: true,
          customRender: (text, record) => {
            return record.deviceName || "--";
          },
          scopedSlots: {
            customRender: "deviceName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon"
          },
          onFilter: (value, record) => record.deviceName.includes(value),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                // this.searchInput.focus();
              }, 0);
            }
          }
        },
        {
          title: "终端型号",
          key: "deviceModelText",
          dataIndex: "deviceModelText",
          width: 120,
          scopedSlots: { customRender: "deviceModelText" },
          filters: [],
          onFilter: (value, record) =>
            record.deviceModelText.indexOf(value) === 0
        },
        {
          title: "MAC",
          key: "mac",
          dataIndex: "mac",
          ellipsis: true,
          scopedSlots: { customRender: "mac" }
        },
        {
          title: "网络情况",
          dataIndex: "onlineStatus",
          key: "onlineStatus",
          width: 100,
          scopedSlots: { customRender: "onlineStatus" },
          filters: [
            { text: "设备在线", value: "1" },
            { text: "设备离线", value: "0" },
            { text: "离线超时", value: "2" }
          ],
          onFilter: (value, record) => record.onlineStatus == value,
          filterMultiple: false
        },
        {
          title: "操作",
          width: 80,
          fiexd: "right",
          key: "action",
          scopedSlots: { customRender: "action" }
        }
      ],
      selectedList: [], //已选点位列表,
      filerParams: {
        orderBy: "community_id",
        desc: "desc",
        communityName: "",
        deviceName: "",
        onlineStatus: "",
        watchMode: [],
        mac: null
        //
      },
      //一键选点
      fastSelectModel: false,
      showFastFooter: false,
      fastInputPlaceholder: "点位数量，最多",
      countInputErr: false,
      countInputErr2: false,
      fastInfo: {
        doorNum: "", //点位数量
        areaType: "2", //区域类型
        compareType: "1", //比较类型 1-等于
        count: "" //区域数量
      }, //一键选点选项
      fastResult: [], //一键选点查询到的点位
      fastBtnLoading: false,
      showfastRestultTip: false,
      userInfo: "",
      rowMaxLength: "",
      bottom: 10, //受众设置底部按钮的距离
      paginationBottom: 58, //受众设置底部按钮的距离
      saleIncomeModal: false, // 销售收入弹框
      income: 0, // 销售收入
      columnSaleIncome: [
        {
          title: "刊例价",
          key: "price",
          scopedSlots: { customRender: "publicationPrice" }
        },
        {
          title: "投放数量",
          dataIndex: "count",
          key: "count",
          scopedSlots: { customRender: "pointCount" }
        },
        { title: "投放要求", dataIndex: "demand", key: "demand" },
        {
          title: "投放日期",
          dataIndex: "date",
          key: "date"
        },
        {
          title: "销售收入",
          dataIndex: "income",
          key: "income",
          scopedSlots: { customRender: "saleIncomeCell" }
        }
      ],
      tableDataSaleIncome: [],
      receiveArr: [], //接收导入的数据
      dayColor: -1,
      onlineDay: 0,
      sortMode: "", //顺序
      sortField: "", //需要排序的字段
      is_show_spaceId: "", //受众类型是否显示
      deliveryPeriod:
        JSON.parse(sessionStorage.getItem("formItem")).deliveryPeriod || "", //上一步选择的播放时段
      deliveryPeriodConfig: {
        allDayPointsRules: {}, //24小时霸屏
        allDayTimes: [], //24小时霸屏
        goldPointsRules: {}, // 黄金时段 次数
        goldTimes: [], // 黄金时段 时间秒数
        commonPointsRules: {}, //普通时段
        commonTimes: [] //普通时段  现在是后端拿数据不需要前端判断属否是地方还是全国
      },
      //级联多选标签数据源
      tagsTree: [],
      tagIds: [],
      isIncludeStr: "包含",
      tabsValue: "0",
      //是否包含标签
      tagReverseFlag: true,
      //下一步spin 点位过多的时候会出现卡顿
      valiateLoading: false
    };
  },
  created() {
    let that = this;
    getDeliveryPeriodConfig()
      .then(data => {
        this.deliveryPeriodConfig = data;
        let x = this.filterObj;
        let _obj = {
          beginTime: x.beginTime,
          endTime: x.endTime,
          playDuration: x.playDuration == undefined ? 10 : x.playDuration,
          playTimes: x.playTimes,
          city: "[]",
          area: "[]",
          province: "[]",
          deliveryPeriod: that.deliveryPeriod
        };
        sessionStorage.setItem("importWorkeFun", JSON.stringify(_obj));
        this.getScreenWidth();
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        /**
         * 初始化获取地区信息
         */
        this.editPlanId = window.sessionStorage.planId;
        // 侧边栏数据
        this.formItem = JSON.parse(sessionStorage.getItem("formItem"));
        if (!this.formItem.condition) {
          this.$set(this.formItem, "condition", "");
        }
        // 获取设备信息
        // this.getDeviceModel();
        // 获取本地缓存进行数据填充
        this.setTargetData();
        //年份
        const thisYear = new Date().getFullYear();
        for (let i = 1919; i <= thisYear; i++) {
          let obj = {
            name: i,
            id: i,
            type: "years"
          };
          this.yearsArr.push(obj);
        }
        //省份
        this.getProvinceArr();
        //区域选择列表
        this.getAreaDataList(1);
        // 终端型号列表，用于表格筛选
        this.getMachineArr();
        this.is_show_spaceId = sessionStorage.getItem("spaceId");
      })
      .catch(err => {
        this.$message.warning(err ? err : "获取播放时段信息失败");
      });
  },
  watch: {
    formItem: {
      handler(newVal) {
        sessionStorage.setItem("formItem", JSON.stringify(newVal));
      },
      deep: true
    },
    // 机型区域点位信息
    modelInfoList: {
      handler(newVal) {
        sessionStorage.setItem("modelInfoList", JSON.stringify(newVal));
      },
      deep: true
    },
    "$store.state.inputNetwork"(v) {
      if (this.selectedList.length == 0) {
        this.selectedList.push(...v);
      } else {
        for (let item of v) {
          if (
            this.selectedList.every(currentVal => currentVal.id != item["id"])
          ) {
            this.selectedList.push(item);
          }
        }
      }

      this.areaDataListRow = this.selectedList.map(item => {
        item.areaString =
          (item.province || "") +
          "-" +
          (item.city || "") +
          "-" +
          (item.area || "");
        return item.id;
      });
    },
    tabsValue(newVal) {
      if (newVal == "0") {
        this.isIncludeStr = "包含";
      } else {
        this.isIncludeStr = "不包含";
      }
      if (this.tagIds.length > 0) {
        this.current = 1;
        this.getAreaDataList(1);
      }
    }
  },
  computed: {
    scrollAreaDataList: function() {
      return this.areaDataList.slice(
        this.tableDataCursor - 20,
        this.tableDataCursor
      );
    },
    filterObj: function() {
      let {
        playSecond,
        playCounts,
        startDate,
        endDate
      } = this.$refs.choosePoint;

      if (!playCounts) {
        //根据上一步不同的播放时段初始化不同的参数
        playCounts = this.setPlayCounts(this.deliveryPeriod, playSecond);
      }
      let info = {
        companyId: this.userInfo.asrId,
        beginTime: moment(startDate).format("YYYY/MM/DD"),
        endTime: moment(endDate).format("YYYY/MM/DD"),
        playDuration: playSecond,
        // playDuration: 10,
        // playTimes: playCounts,
        playTimes: Number(playCounts),
        province: this.provinceActive.length > 0 ? this.provinceActive : null,
        city: this.cityActive.length > 0 ? this.cityActive : null,
        area: this.areaActive.length > 0 ? this.areaActive : null,
        deviceModel: this.machineActive.length > 0 ? this.machineActive : null,
        buildType: this.buildTypeActive || null,
        residentMinNum: this.houseNumMin || null,
        residentMaxNum: this.houseNumMax || null,
        minPrice: this.buildPriceMin || null,
        maxPrice: this.buildPriceMax || null,
        peopleMinNum: this.personMin || null,
        peopleMaxNum: this.personMax || null,
        moveInYear: this.yearsActive || null,
        pageSize: this.pageSize,
        pageNum: this.current,
        satisfyPortion: true,
        spaceId: this.formItem.positionId * 1,
        mac: this.filerParams.mac,
        onlineDayNum: this.onlineDay,
        sortMode: this.sortMode,
        sortField: this.sortField,
        deliveryPeriod: this.formItem.deliveryPeriod * 1,
        tagIds: this.tagIds.length ? this.tagIds.map(Number) : null,
        tagReverseFlag: this.tabsValue == "0" ? null : true
      };
      sessionStorage.setItem("spaceId", info.spaceId);
      if (this.excludeActive !== "") {
        let excludeInd = this.formItem.adSystemId;
        if (this.excludeActive == 1) {
          info.excludeIndType = 1;
          info.excludeInd = excludeInd[excludeInd.length - 1];
        } else if (this.excludeActive == 2) {
          info.excludeIndType = 2;
          info.excludeInd = excludeInd[excludeInd.length - 1];
        }
      }
      if (this.filerParams.deviceName != "") {
        info.deviceName = this.filerParams.deviceName;
      }
      if (this.filerParams.onlineStatus != "") {
        info.onlineStatus = this.filerParams.onlineStatus;
      }
      if (this.filerParams.communityName != "") {
        info.communityName = this.filerParams.communityName;
      }
      if (this.filerParams.watchMode.length > 0) {
        info.watchMode = this.filerParams.watchMode;
      }
      return info;
    },
    ...mapState([
      "framesList",
      "currentAdMaterialDetail",
      "framesTagColor",
      "totalPlayDateNum",
      "playDateNum",
      "selectDateList",
      "isUpload"
    ])
  },
  directives: {
    sliceSourceData: {
      bind: function(el, binding) {
        const selectWrap = el.querySelector(".ant-table-body");
        selectWrap.addEventListener("scroll", function() {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance === 0) {
            binding.value("down", this);
          } else if (this.scrollTop === 0) {
            binding.value("up", this);
          }
        });
      }
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    // 监听storage,更新地图选点数据
    let _this = this;
    window.addEventListener("storage", function(e) {
      if (e.key == "selectedList" && e.newValue !== null) {
        _this.selectedList = _this.uniqueArrAndReplace(JSON.parse(e.newValue));
      }
    });
  },
  mounted() {
    this.getTagsTree();
  },
  beforeDestroy() {
    if (sessionStorage.getItem("edit") === "edit") {
      return;
    }
    cacheDrafts(2, { devInfo: JSON.stringify(this.cacheData()) });
  },
  methods: {
    scrollUpdateTableSource(direction, scrollTarget) {
      if (
        this.scrollTableLoading ||
        (direction === "up" && this.tableDataCursor <= 20) ||
        (direction === "down" &&
          this.tableDataCursor >= this.areaDataList.length)
      )
        return;
      this.scrollTableLoading = true;
      if (direction === "up") {
        this.tableDataCursor -= 10;
        scrollTarget.scrollTop = scrollTarget.scrollTop + 540;
      } else {
        this.tableDataCursor += 10;
        scrollTarget.scrollTop = scrollTarget.scrollTop - 540;
      }
      setTimeout(() => {
        this.scrollTableLoading = false;
      }, 300);
    },
    // 编辑计划时，获取已选点位
    getAdMachineInfoByPointId(planId) {
      let editDetail = JSON.parse(sessionStorage.getItem("editPlanDetail"));
      if (
        !planId ||
        planId != editDetail.planId ||
        !editDetail.regionIdToPointId ||
        editDetail.regionIdToPointId.length == 0
      )
        return;
      api
        .postApiSpecil("/platform/filtrate/filtrateMachineByPointIds", {
          pointIds: Object.keys(editDetail.regionIdToPointId)
        })
        .then(res => {
          if (res.data.code === 200 && Array.isArray(res.data.data)) {
            this.selectedList = res.data.data || [];
            this.areaDataListRow = this.selectedList.map(item => {
              item.areaString =
                (item.provinceName || "") +
                "-" +
                (item.cityName || "") +
                "-" +
                (item.areaName || "");
              return item.id;
            });
            sessionStorage.setItem(
              "areaDataListRow",
              JSON.stringify(this.areaDataListRow)
            );
            // sessionStorage.setItem(
            //   "selectedList",
            //   JSON.stringify(this.selectedList)
            // );
            this.$localForage.setItem("selectedList", this.selectedList);
          } else {
            this.$message.warning(res.data.msg || "查看异常");
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    //获取浏览器宽度
    getScreenWidth() {
      let width = document.body.clientWidth;
      if (width > 1900) {
        this.rowMaxLength = 20;
      } else if (width > 1420) {
        this.rowMaxLength = 14;
      } else {
        this.rowMaxLength = 12;
      }
      window.onresize = () => {
        return (() => {
          let width = document.body.clientWidth;
          if (width > 1900) {
            this.rowMaxLength = 20;
          } else if (width > 1420) {
            this.rowMaxLength = 13;
          } else {
            this.rowMaxLength = 12;
          }
        })();
      };
    },
    // 获取本地缓存进行数据填充
    async setTargetData() {
      // 设置受众性别和年龄
      this.formItem.priceStrategy == 2 && this.getConditionList();
      // this.selectedList = JSON.parse(sessionStorage.getItem("selectedList"));
      this.selectedList = await this.$localForage.getItem("selectedList");
      // 有缓存的话，根据缓存设置已选点位，若没有则从计划的设备下发列表获取
      if (Array.isArray(this.selectedList)) {
        this.areaDataListRow = this.selectedList.map(item => {
          //导入表格的时候字段名不一样
          item.areaString =
            (item.provinceName || item.province || "") +
            "-" +
            (item.cityName || item.city || "") +
            "-" +
            (item.areaName || item.area || "");
          return item.id;
        });
        sessionStorage.setItem(
          "areaDataListRow",
          JSON.stringify(this.areaDataListRow)
        );
      } else {
        this.selectedList = [];
        this.getAdMachineInfoByPointId(this.editPlanId);
      }
      this.modelInfoList =
        JSON.parse(sessionStorage.getItem("modelInfoList")) || [];
      if (this.modelInfoList && this.modelInfoList.length) {
        this.step = 2;
        let tempSelectedInfo = JSON.parse(
          sessionStorage.getItem("selectedInfo")
        );
        if (tempSelectedInfo) {
          this.provinceActive = tempSelectedInfo.provinceActive || [];
          this.cityActive = tempSelectedInfo.cityActive || [];
          this.areaActive = tempSelectedInfo.areaActive || [];
          this.machineActive = tempSelectedInfo.machineActive || [];
          this.buildTypeActive = tempSelectedInfo.buildTypeActive || "";
          this.yearsActive = tempSelectedInfo.yearsActive || "";
          this.excludeActive = tempSelectedInfo.excludeActive || "";
          this.houseNumMin = tempSelectedInfo.houseNumMin || "";
          this.houseNumMax = tempSelectedInfo.houseNumMax || "";
          this.buildPriceMax = tempSelectedInfo.buildPriceMax || "";
          this.buildPriceMin = tempSelectedInfo.buildPriceMin || "";
          this.personMax = tempSelectedInfo.personMax || "";
          this.personMin = tempSelectedInfo.personMin || "";
          this.tags = tempSelectedInfo.tags || [];
          this.tagIds = tempSelectedInfo.tagIds || [];
          this.tabsValue = tempSelectedInfo.tabsValue || "0";
          if (this.cityActive.length > 0) {
            this.getCityArr(this.provinceActive[0]);
            if (this.areaActive.length > 0) {
              this.getAreaArr(this.cityActive[0]);
            }
          }
        }
      } else {
        this.step = 1;
      }
    },
    // 获取设备类型配置信息
    getDeviceModel() {
      this.modelSpinning = true;
      api.getApi("/machine/deviceModel/all", {}).then(res => {
        if (res.data.code === 200) {
          this.typeInfos = res.data.data.map(item => {
            return {
              modelID: item.deviceModel,
              model: item.deviceModelText,
              adSize: {
                h: item.deviceModelAttributes[0].height,
                w: item.deviceModelAttributes[0].width
              },
              materialSize: {
                h: item.deviceModelAttributes[0].materialAttribute
                  ? item.deviceModelAttributes[0].materialAttribute[0].height
                  : "",
                w: item.deviceModelAttributes[0].materialAttribute
                  ? item.deviceModelAttributes[0].materialAttribute[0].width
                  : ""
              },
              checkboxModel: false,
              materialSizeText: item.deviceModelAttributes[0].materialSizeText
            };
          });
          // 根据机型个数动态修改宽度
          // let typeWarp = this.$refs.typeWarp;
          // typeWarp.style.width = (270 * this.typeInfos.length) + 'px';
          this.modelSpinning = false;
        } else {
          this.$message.warning(res.data.msg || "设备信息异常");
        }
      });
    },
    getConditionList() {
      let conditionList =
        JSON.parse(sessionStorage.getItem("conditionList")) || [];
      conditionList.forEach(item => {
        if (item.conditionType == 2) {
          this.sexValue.push(item.conditionCode);
        } else {
          this.ageValue.push(item.conditionCode);
        }
      });
    },
    //修改受众类型
    changeCondition() {
      let arr = [];
      let conditionList = [];
      for (let data of this.sexValue) {
        let str = this.conversionValue(data, this.sexOptions);
        let obj = {};
        obj.conditionCode = data;
        obj.conditionValue = str;
        obj.conditionType = 2;
        conditionList.push(obj);
        arr.push(str);
      }
      for (let data of this.ageValue) {
        let str = this.conversionValue(data, this.ageOptions);
        let obj = {};
        obj.conditionCode = data;
        obj.conditionValue = str;
        obj.conditionType = 7;
        conditionList.push(obj);
        arr.push(str);
      }
      this.formItem.condition = arr.join(";");
      sessionStorage.setItem("conditionList", JSON.stringify(conditionList));
    },
    conversionValue(val, arr) {
      for (let data of arr) {
        if (val == data.value) {
          return data.label;
        }
      }
    },
    /**区域范围*/
    //查询数据 type:1-正常查询 2-一键快速选点
    getAreaDataList(type) {
      if (!(this.formItem.positionId * 1 > 0)) return;
      if (type == 1) {
        this.valiateAdMachineShareData = {
          userId: this.userInfo.userId,
          beginTime: this.filterObj.beginTime,
          endTime: this.filterObj.endTime,
          playDuration: this.filterObj.playDuration,
          playTimes: this.filterObj.playTimes,
          spaceId: this.filterObj.spaceId,
          onlineDayNum: this.onlineDay
        };
        this.getAdMachineInfo();
      } else {
        this.fastBtnLoading = true;
        let params = {
          ...this.filterObj,
          userId: this.userInfo.userId,
          type: this.fastInfo.areaType,
          count: this.fastInfo.count * 1,
          total: this.fastInfo.doorNum * 1,
          //这里添加
          onlineDayNum: this.onlineDay
        };

        delete params.pageNum;
        delete params.pageSize;
        api.postApi("/select/quickSelect", params).then(res => {
          if (res.data.code == 200) {
            this.fastResult = res.data.data;
            this.showFastFooter = true;
            this.showfastRestultTip = true;
            this.fastBtnLoading = false;
          } else {
            this.fastBtnLoading = false;
            this.$message.warning("一键选点查询失败，" + res.data.msg);
          }
        });
      }
    },
    getAdMachineInfo() {
      this.targetSpinning = true;
      api
        .postApiSpecil("/platform/filtrate/filtrateMachine", this.filterObj)
        .then(res => {
          if (res.data.code == 200) {
            this.total = res.data.data.total;
            this.areaDataList = res.data.data.list;
            for (let data of this.areaDataList) {
              (data.adSize = data.size),
                (data.onlineDayNum = data.onlineDayNum + "天");
              data.communityName = data.communityName || "--";
              data.cityName = data.cityName || "--";
              data.areaName = data.areaName || "--";
              data.provinceName = data.provinceName || "--";
            }
            this.tableDataCursor = 20;
          } else {
            this.$message.warning("获取设备列表失败," + res.data.msg);
          }
        })
        .finally(() => {
          this.targetSpinning = false;
        });
    },
    unlimitedSelect(type) {
      if (type == "provinces") {
        this.provinceActive = [];
        this.cityArr = [];
        this.cityActive = [];
        this.areaArr = [];
        this.areaActive = [];
      } else if (type == "city") {
        this.cityActive = [];
        this.areaArr = [];
        this.areaActive = [];
      } else if (type == "area") {
        this.areaActive = [];
      } else if (type == "machine") {
        this.machineActive = [];
      } else if (type === "resetData") {
        // 一键恢复默认
        this.provinceActive = [];
        this.cityArr = [];
        this.cityActive = [];
        this.areaArr = [];
        this.areaActive = [];
        this.machineActive = [];
        this.clearTags();
        return;
      } else if (type == "day") {
        this.dayColor = -1;
        this.onlineDay = 0;
      }
      this.current = 1;
      this.getAreaDataList(1);
    },
    //点击选项
    handleChoose(type, params, index) {
      switch (type) {
        case "province":
          if (this.provinceActive.indexOf(index) != -1) {
            //取消选中,变成不限
            this.provinceActive.splice(this.provinceActive.indexOf(index), 1);
          } else {
            //选中
            this.provinceActive.push(index);
          }
          if (this.provinceActive.length !== 1) {
            //超过一个。下级变成不限
            this.cityActive = [];
            this.cityArr = [];
            this.areaActive = [];
            this.areaArr = [];
          } else {
            this.getCityArr(this.provinceActive[0]);
          }
          break;
        case "city":
          if (this.cityActive.indexOf(index) != -1) {
            //取消选中
            this.cityActive.splice(this.cityActive.indexOf(index), 1);
          } else {
            //选中
            this.cityActive.push(index);
          }
          if (this.cityActive.length !== 1) {
            //超过一个。下级变成不限
            this.areaActive = [];
            this.areaArr = [];
          } else {
            this.getAreaArr(this.cityActive[0]);
          }
          break;
        case "area":
          if (this.areaActive.indexOf(index) != -1) {
            //取消选中
            this.areaActive.splice(this.areaActive.indexOf(index), 1);
          } else {
            //选中
            this.areaActive.push(index);
          }
          break;
        case "machine":
          if (this.machineActive.indexOf(index) != -1) {
            //取消选中
            this.machineActive.splice(this.machineActive.indexOf(index), 1);
          } else {
            //选中
            this.machineActive.push(index);
          }
          break;
        case "day":
          this.dayColor = this.onLineDasy.indexOf(params);
          this.onlineDay = params;
          break;
        default:
          break;
      }
      this.current = 1;
      this.getAreaDataList(1);
    },
    //其他-选择器筛选
    otherChoose(params) {
      let obj = {};
      if (params.type == "buildType") {
        this.buildTypeActive = params.name;
        this.buildTypeVisible = false;
        obj = { ...params };
        this.tags.some(item => {
          if (item.type == "buildType") {
            this.tags.splice(this.tags.indexOf(item), 1);
          }
        });
      } else if (params.type == "years") {
        this.yearsActive = params.id;
        this.yearsVisible = false;
        obj = { ...params, name: "入住年份：" + params.name };
        this.tags.some(item => {
          if (item.type == "years") {
            this.tags.splice(this.tags.indexOf(item), 1);
          }
        });
      } else if (params.type == "excludeType") {
        this.excludeActive = params.id;
        this.excludeVisible = false;
        obj = { ...params, name: params.name };
        this.tags.some(item => {
          if (item.type == "excludeType") {
            this.tags.splice(this.tags.indexOf(item), 1);
          }
        });
      }
      this.tags.push(obj);
      this.current = 1;
      this.getAreaDataList(1);
    },
    //其他-区间输入确定
    tagsInputConfirm(type) {
      let obj = {};
      if (type == "houseNum") {
        if (this.houseNumMin !== "" && this.houseNumMax !== "") {
          this.houseNumVisible = false;
          this.houseNumActive = true;
          obj = {
            name: "住户数：" + this.houseNumMin + "-" + this.houseNumMax,
            type: "houseNum"
          };
          this.tags.some(item => {
            if (item.type == "houseNum") {
              this.tags.splice(this.tags.indexOf(item), 1);
            }
          });
          this.tags.push(obj);
          this.current = 1;
          this.getAreaDataList(1);
        }
      } else if (type == "buildPrice") {
        if (this.buildPriceMin !== "" && this.buildPriceMax !== "") {
          this.buildPriceVisible = false;
          this.buildPriceActive = true;
          obj = {
            name: "楼盘价格：" + this.buildPriceMin + "-" + this.buildPriceMax,
            type: "buildPrice"
          };
          this.tags.some(item => {
            if (item.type == "buildPrice") {
              this.tags.splice(this.tags.indexOf(item), 1);
            }
          });
          this.tags.push(obj);
          this.current = 1;
          this.getAreaDataList(1);
        }
      } else if (type == "person") {
        if (this.personMin !== "" && this.personMax !== "") {
          this.personVisible = false;
          this.personActive = true;
          obj = {
            name: "人流量：" + this.personMin + "-" + this.personMax,
            type: "person"
          };
          this.tags.some(item => {
            if (item.type == "person") {
              this.tags.splice(this.tags.indexOf(item), 1);
            }
          });
          this.tags.push(obj);
          this.current = 1;
          this.getAreaDataList(1);
        }
      }
    },
    //其他-区间清除
    clearTagsInput(type) {
      if (type == "houseNum") {
        this.houseNumMin = "";
        this.houseNumMax = "";
      } else if (type == "buildPrice") {
        this.buildPriceMin = "";
        this.buildPriceMax = "";
      } else if (type == "person") {
        this.personMin = "";
        this.personMax = "";
      }
    },
    //tags-删除
    deleteTag(item, index) {
      if (item.type == "buildType") {
        this.buildTypeActive = "";
      } else if (item.type == "houseNum") {
        this.houseNumActive = false;
        this.houseNumMin = "";
        this.houseNumMax = "";
      } else if (item.type == "buildPrice") {
        this.buildPriceActive = false;
        this.buildPriceMin = "";
        this.buildPriceMax = "";
      } else if (item.type == "person") {
        this.personActive = false;
        this.personMin = "";
        this.personMax = "";
      } else if (item.type == "years") {
        this.yearsActive = "";
      } else if (item.type == "excludeType") {
        this.excludeActive = "";
      }
      let deleteItem = this.tags.splice(index, 1);
      if (item.type == "tag") {
        let tagIdindex = this.tagIds.findIndex(tagId => {
          return tagId == deleteItem[0].id;
        });
        //修复删除下面标签级联ui不变化的问题
        this.$refs.multipleCascderRef.handleDeselect(
          this.tagIds.splice(tagIdindex, 1)[0]
        );
        if (this.tagIds.length <= 0) {
          this.current = 1;
          this.getAreaDataList(1);
        }
      } else {
        this.current = 1;
        this.getAreaDataList(1);
      }
    },
    //清空条件
    clearTags() {
      this.tags = [];
      this.tagIds = [];
      this.tabsValue = "0";
      this.buildTypeActive = "";
      this.houseNumActive = false;
      this.houseNumMin = "";
      this.houseNumMax = "";
      this.buildPriceActive = false;
      this.buildPriceMin = "";
      this.buildPriceMax = "";
      this.personActive = false;
      this.personMin = "";
      this.personMax = "";
      this.yearsActive = "";
      this.excludeActive = "";
      this.current = 1;
      this.getAreaDataList(1);
    },
    //获取省份列表
    getProvinceArr() {
      let {
        playSecond,
        playCounts,
        startDate,
        endDate
      } = this.$refs.choosePoint;
      playCounts = this.setPlayCounts(this.deliveryPeriod, playSecond);
      let info = {
        beginTime: moment(startDate).format("YYYY/MM/DD"),
        endTime: moment(endDate).format("YYYY/MM/DD"),
        playDuration: playSecond,
        playTimes: Number(playCounts),
        companyId: this.userInfo.asrId,
        selectType: 0 // 0:查省 1:市 2:区
      };
      api.postApiSpecil("/platform/filtrate/filtrateArea", info).then(res => {
        if (res.data.code == 200) {
          this.provincesArr = res.data.data || [];
        } else {
          this.$warning("获取省份信息失败," + res.data.msg);
        }
      });
    },
    //获取城市列表
    getCityArr(provinceId) {
      let {
        playSecond,
        playCounts,
        startDate,
        endDate
      } = this.$refs.choosePoint;
      playCounts = this.setPlayCounts(this.deliveryPeriod, playSecond);
      let info = {
        areaCode: [provinceId],
        beginTime: moment(startDate).format("YYYY/MM/DD"),
        endTime: moment(endDate).format("YYYY/MM/DD"),
        playDuration: playSecond,
        playTimes: Number(playCounts),
        companyId: this.userInfo.asrId,
        selectType: 1
      };
      api.postApiSpecil("/platform/filtrate/filtrateArea", info).then(res => {
        if (res.data.code == 200) {
          this.cityArr = res.data.data;
        } else {
          this.$warning("获取城市信息失败," + res.data.msg);
        }
      });
    },
    //获取区县列表
    getAreaArr(cityId) {
      let {
        playSecond,
        playCounts,
        startDate,
        endDate
      } = this.$refs.choosePoint;
      playCounts = this.setPlayCounts(this.deliveryPeriod, playSecond);
      let info = {
        areaCode: [cityId],
        beginTime: moment(startDate).format("YYYY/MM/DD"),
        endTime: moment(endDate).format("YYYY/MM/DD"),
        playDuration: playSecond,
        playTimes: Number(playCounts),
        companyId: this.userInfo.asrId,
        selectType: 2
      };
      api.postApiSpecil("/platform/filtrate/filtrateArea", info).then(res => {
        if (res.data.code == 200) {
          this.areaArr = res.data.data;
        } else {
          this.$warning("获取区县信息失败," + res.data.msg);
        }
      });
    },

    setPlayCounts(deliveryPeriod, playSecond) {
      let playCounts;
      //根据上一步不同的播放时段初始化不同的参数
      switch (Number(deliveryPeriod)) {
        case 1:
          playCounts = this.deliveryPeriodConfig.commonPointsRules[
            playSecond
          ][0];
          break;
        case 2:
          playCounts = this.deliveryPeriodConfig.goldPointsRules[playSecond][0];
          break;
        case 3:
          playCounts = this.deliveryPeriodConfig.allDayPointsRules[
            playSecond
          ][0];
          break;
        default:
          break;
      }
      return playCounts;
    },
    //获取机器列表
    getMachineArr() {
      if (this.formItem.positionId * 1 > 0) {
        api
          .getApi("/select/getModelInfo?spaceIds=" + [this.formItem.positionId])
          .then(res => {
            if (res.data.code == 200) {
              //如果两次返回数据类型不一样，清空已选点位
              this.machineArr = res.data.data;
              if (sessionStorage.getItem("machineArr") != undefined) {
                let length = JSON.parse(sessionStorage.getItem("machineArr"))
                  .length;
                if (length != res.data.data.length) {
                  this.selectedList = [];
                }
              }
              this.selectedColumns[3].filters = res.data.data.map(item => {
                return {
                  text: item.deviceModelText,
                  value: item.deviceModelText
                };
              });
              //每次请求都记录一下返回值
              sessionStorage.setItem(
                "machineArr",
                JSON.stringify(res.data.data)
              );
            } else {
              this.$message.warning("获取设备型号失败," + res.data.msg);
            }
          });
      } else {
        this.$message.warning("广告位置信息错误！");
      }
    },
    //区域范围列表改变页数
    changePage(page) {
      this.current = page;
      this.getAreaDataList(1);
    },
    onShowSizeChange(current, pageSize) {
      this.current = current;
      this.pageSize = pageSize;
      this.getAreaDataList(1);
    },
    //区域范围列表搜索
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    handleSearchSelected(selectedKeys, confirm) {
      confirm();
      this.selectSearchText = selectedKeys[0];
    },
    handleResetSelected(clearFilters) {
      clearFilters();
      this.selectSearchText = "";
    },
    changeList(pagination, filters, sorter) {
      if (sorter.columnKey) {
        this.filerParams.orderBy = sorter.columnKey;
        this.filerParams.desc = sorter.order == "ascend" ? "asc" : "desc";
      }
      if (sorter.field != "onlineDayNum") {
        this.sortMode = "";
        this.sortField = "";
      }
      if (sorter.field == "onlineDayNum") {
        this.sortField = "onlineDayNum";
        if (sorter.order == "ascend") {
          this.sortMode = "asc";
        } else if (sorter.order == "descend") {
          this.sortMode = "desc";
        } else {
          this.sortMode = "";
        }
        //
      }
      if (filters.mac) {
        this.filerParams.mac = filters.mac.join(",");
      }
      if (filters.watchModeName) {
        this.filerParams.watchMode = filters.watchModeName.join(",");
      }
      if (filters.deviceName) {
        this.filerParams.deviceName = filters.deviceName[0];
      }
      if (filters.communityName) {
        this.filerParams.communityName = filters.communityName[0];
      }
      if (filters.onlineStatus && filters.onlineStatus.length > 0) {
        this.filerParams.onlineStatus = filters.onlineStatus[0];
        this.areaDataListColumns[1].filteredValue = filters.onlineStatus;
      }
      // if(filerParams)
      else {
        //通信状态筛选不选中
        this.filerParams.onlineStatus = "";
        this.areaDataListColumns[1].filteredValue = [];
      }

      this.current = 1;
      this.getAreaDataList(1);
    },
    //手动选择/取消选择某列的回调
    areaSelectOne(record, selected) {
      if (selected) {
        //添加
        let obj = {
          ...record,
          areaString:
            (record.provinceName || "") +
            "-" +
            (record.cityName || "") +
            "-" +
            (record.areaName || "")
        };
        this.selectedList.push(obj);
        this.selectedList = this.uniqueArr(this.selectedList);
      } else {
        //删除
        for (let data of this.selectedList) {
          if (data.id == record.id) {
            this.selectedList.splice(this.selectedList.indexOf(data), 1);
          }
        }
      }
      this.areaDataListRow = this.selectedList.map(item => item.id);
    },
    //手动选择/取消选择所有列的回调
    areaSelectAll(selected) {
      if (selected) {
        this.selectedList = this.selectedList.concat(this.areaDataList);
        this.selectedList = this.selectedList.map(item => {
          item.areaString = item.provinceName + item.cityName + item.areaName;
          if (item.areaString == "------") {
            item.areaString = "--";
          }
          return item;
        });
        this.selectedList = this.uniqueArr(this.selectedList);
      } else {
        let a = [...this.selectedList];
        for (let item of a) {
          for (let data of this.areaDataList) {
            if (item.id == data.id) {
              this.selectedList.splice(this.selectedList.indexOf(item), 1);
            }
          }
        }
      }
      this.areaDataListRow = this.selectedList.map(item => item.id);
    },
    //数组去重
    uniqueArr(arr) {
      const res = new Map();
      return arr.filter(a => !res.has(a.id) && res.set(a.id, 1));
    },
    //数组去重
    uniqueArrAndReplace(arr) {
      const res = new Map();
      let resultArr = [];
      arr.forEach(a => {
        if (!res.has(a.id) && res.set(a.id, 1)) {
          let tempObj = {};
          tempObj.id = a.id || "";
          tempObj.areaString = a.areaString || "";
          tempObj.areaName = a.area || "";
          tempObj.buildNumber = a.buildCount || "";
          tempObj.buildPrice = a.buildPrice || "";
          tempObj.buildType = a.buildType || "";
          tempObj.cityName = a.city || "";
          tempObj.communityName = a.communityName;
          tempObj.companyId = a.companyId || "";
          tempObj.companyName = a.companyName || "";
          tempObj.devOnlineStatus = a.devOnlineStatus;
          tempObj.deviceCode = a.deviceCode || "";
          tempObj.deviceModel = a.deviceModel || "";
          tempObj.deviceModelText = a.version || "";
          tempObj.deviceName = a.deviceName || "";
          tempObj.inYear = a.moveInYear || "";
          tempObj.mac = a.mac || "";
          tempObj.onlineStatus = a.deviceStatus || "";
          tempObj.peopleFlowNumber = a.humanTraffic || "";
          tempObj.peopleNum = a.residentCount || "";
          tempObj.provinceName = a.province || "";
          tempObj.size = `${a.adSize.split("*")[0].trim()}*${a.adSize
            .split("*")[1]
            .trim()}`;
          tempObj.satisfyPortion = true;
          resultArr.push(tempObj);
        }
      });
      return resultArr;
    },
    /**已选点位*/
    //删除已选点位
    delectSelected(row) {
      this.selectedList.splice(this.selectedList.indexOf(row), 1);
      this.areaDataListRow.splice(this.areaDataListRow.indexOf(row.id), 1);
    },
    //一键删除
    delectSelectedFast() {
      this.selectedList = this.selectedList.filter(
        key => !this.selectedListRow.includes(key.id)
      );
      this.areaDataListRow = this.selectedList.map(item => {
        return item.id;
      });
    },
    // 一键清空所有已选
    delectSelectedAll() {
      this.selectedList = [];
      this.areaDataListRow = [];
    },
    // 导出点位
    exportPoint() {
      if (this.selectedList.length == 0) {
        this.$message.warning("当前数据为空哦~");
        return;
      }
      let jsonData = [];
      //因为是从导入进来的数据所以要改变一下城市的名字
      this.selectedList.forEach(item => {
        if (item.area) item.areaName = item.area;
        if (item.city) item.cityName = item.city;
        if (item.province) item.provinceName = item.province;
        jsonData.push(item);
      });
      //列标题
      let str = `<tr>
                  <td>所属省份</td>
                  <td>所属城市</td>
                  <td>区/县</td>
                  <td>网点资源</td>
                  <td>楼盘类型</td>
                  <td>住户数</td>
                  <td>楼盘价格</td>
                  <td>点位名称</td>
                  <td>详细地址</td>
                  <td>点位ID</td>
                  <td>MAC</td>
                  <td>终端型号</td>
                  <td>所属公司</td>
                  <td>网络情况</td>
                  <td>连续在线</td>
                </tr>`;

      //    <td>监播方式</td> , 'watchModeName'
      let tempColumn = [
        "provinceName",
        "cityName",
        "areaName",
        "communityName",
        "buildType",
        "buildNumber",
        "buildPrice",
        "deviceName",
        "communityAddress",
        "id",
        "mac",
        "deviceModelText",
        "companyName",
        "onlineStatus",
        "onlineDayNum"
      ];
      //循环遍历，每行加入tr标签，每个单元格加td标签
      for (let i = 0; i < jsonData.length; i++) {
        str += "<tr>";
        for (const item of tempColumn) {
          if (item == "onlineDayNum") {
            //如果连续在线天数是数字的话，后边加天
            if (typeof jsonData[i][item] == "number") {
              jsonData[i][item] = jsonData[i][item] + "天";
            }
          }
          if (item == "onlineStatus") {
            str += `<td>${(jsonData[i][item] == 1
              ? "设备在线"
              : jsonData[i][item] == 0
              ? "设备离线"
              : jsonData[i][item] == 2
              ? "离线超时"
              : "") + "\t"}</td>`;
          } else {
            //增加\t为了不让表格显示科学计数法或者其他格式
            if (
              !isNaN(Number(jsonData[i][item])) &&
              jsonData[i][item] !== undefined &&
              jsonData[i][item] !== null
            ) {
              str += `<td style="mso-number-format:'\@';">${
                jsonData[i][item] ? jsonData[i][item] : "--" + "\t"
              }</td>`;
            } else {
              str += `<td>${
                jsonData[i][item] ? jsonData[i][item] : "--" + "\t"
              }</td>`;
            }
          }
        }
        str += "</tr>";
      }
      //Worksheet名
      let worksheet = "已选点位";
      // let uri = "data:application/vnd.ms-excel;base64,";
      //下载的表格模板数据
      let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
                                  xmlns:x="urn:schemas-microsoft-com:office:excel"
                                  xmlns="http://www.w3.org/TR/REC-html40">
                                  <head>
                                    <meta charset="utf-8">
                                    <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
                                    <x:Name>${worksheet}</x:Name>
                                    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
                                    </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
                                    </head><body><table>${str}</table></body></html>`;
      let { startDate, endDate } = this.$refs.choosePoint,
        planName =
          JSON.parse(sessionStorage.getItem("formItem")).planName || "",
        beginD = timeFormat.toDate(startDate, ""),
        endD = timeFormat.toDate(endDate, ""),
        timeString = `${planName}${beginD}-${endD}-${
          this.selectedList.length
        }.xls`,
        blob = new Blob([template], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
      if (navigator.msSaveBlob) {
        // 启用IE内置下载器下载
        try {
          window.navigator.msSaveBlob(blob, timeString);
        } catch (e) {
          console.log(e);
        }
      } else {
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = timeString; //下载后文件名
        downloadElement.target = "_blank"; // 针对 ie模式 的浏览器
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }
      // window.location.href = uri + window.btoa(unescape(encodeURIComponent(template)))
    },
    // 一键删除不满足条件点位
    delectSelectedPoints() {
      const deleDataListKey = this.$refs.discontentModal.deleDataList.map(
        item => item.id
      );
      this.selectedList = this.selectedList.filter(key => {
        return !deleDataListKey.includes(key.id);
      });
      this.areaDataListRow = this.selectedList.map(item => {
        return item.id;
      });
      this.$refs.discontentModal.deleDataList = [];
    },
    //查询
    changeSelectedList(pagination, filters, sorter) {
      console.log("params", pagination, filters, sorter);
    },
    //已选列表勾选
    changeSelected(selectedRowKeys) {
      this.selectedListRow = selectedRowKeys;
    },

    /**一键选点*/
    showFastModel() {
      this.fastSelectModel = true;
      this.fastBtnLoading = false;
      this.fastInputPlaceholder = "点位数量，最多" + this.total;
    },
    /**设置地图选点参数*/
    setMapParams() {
      let formItem = JSON.parse(sessionStorage.getItem("formItem")),
        cityObj = this.cityArr[0],
        city = cityObj ? cityObj.areaName || "" : "",
        rid = cityObj ? cityObj.areaCode || "" : "";
      localStorage.setItem(
        "mapParams",
        JSON.stringify({
          provinceId: this.provinceActive[0],
          rid,
          city,
          ls: timeFormat.toDate(formItem.beginTime, "/"),
          le: timeFormat.toDate(formItem.endTime, "/"),
          playCount: formItem.playCounts,
          playSecond: formItem.playSecond,
          suID: this.userInfo.userId,
          adSystemId: formItem.adSystemId,
          adSystemName: formItem.adSystemName,
          positionId: formItem.positionId,
          selectedList: this.selectedList
        })
      );
      let url = `${window.location.protocol}//${
        window.location.host
      }/f_map/ADResourceMap/chooseRes?flag=true`;
      window.open(url);
    },
    //选择区域类型
    changeFastArea() {},
    //一键选点查询
    handleFastSearch() {
      this.showfastRestultTip = false;
      if (this.fastInfo.doorNum == "" || this.fastInfo.count == "") {
        this.$message.warning("请输入查找条件！");
        if (this.fastInfo.count == "") {
          this.countInputErr2 = true;
        } else {
          this.countInputErr2 = false;
        }
        if (this.fastInfo.doorNum == "") {
          this.countInputErr = true;
        } else {
          this.countInputErr = false;
        }
        return false;
      } else {
        if (
          this.fastInfo.count * 1 > this.total ||
          this.fastInfo.count * 1 > this.fastInfo.doorNum * 1 ||
          !(this.fastInfo.count * 1 > 0)
        ) {
          this.countInputErr2 = true;
          return false;
        } else {
          this.countInputErr2 = false;
        }
        if (
          this.fastInfo.doorNum * 1 > this.total ||
          !(this.fastInfo.doorNum * 1 > 0)
        ) {
          this.countInputErr = true;
          return false;
        } else {
          this.countInputErr = false;
        }
      }
      if (this.countInputErr || this.countInputErr2) {
        return false;
      }

      this.getAreaDataList(2);
    },
    //一键选点输入框验证
    checkCountInput() {
      if (this.fastInfo.doorNum * 1 > this.total) {
        this.countInputErr = true;
        this.$message.warning("当前最多可投点位" + this.total + "个！");
      } else if (!(this.fastInfo.doorNum * 1 > 0)) {
        this.$message.warning("请输入正确的数值！");
      } else {
        this.countInputErr = false;
      }
    },
    checkCountInput2() {
      if (
        this.fastInfo.count * 1 > this.fastInfo.doorNum * 1 ||
        !(this.fastInfo.count * 1 > 0)
      ) {
        this.countInputErr2 = true;
        this.$message.warning("请输入正确的数值！");
      } else {
        this.countInputErr2 = false;
      }
    },
    //一键选点确定按钮
    handleFastAction() {
      //添加到已选点位
      for (let item of this.fastResult) {
        let obj = {
          ...item,
          areaString:
            (item.provinceName || "") +
            "-" +
            (item.cityName || "") +
            "-" +
            (item.areaName || ""),
          onlineDayNum: item.onlineDayNum + "天"
        };
        this.selectedList.push(obj);
      }
      this.selectedList = this.uniqueArr(this.selectedList);
      this.areaDataListRow = this.selectedList.map(item => {
        return item.id;
      });
      this.fastSelectModel = false;
      this.$message.success("添加成功！");
    },
    //一键选点模态框关闭
    closeFastModel() {
      this.fastSelectModel = false;
      this.countInputErr2 = false;
      this.countInputErr = false;
      this.fastInfo = {
        doorNum: "", //点位数量
        areaType: "2", //区域类型
        compareType: "1", //比较类型 1-等于
        count: "" //区域数量
      };
      this.showFastFooter = false;
      this.showfastRestultTip = false;
    },
    /**底部按钮*/
    //上一步
    lastStep() {
      this.$router.push("./channelPlanSet");
      // sessionStorage.setItem('selectedList', '[]')
      sessionStorage.setItem("targetSetType", "createing");
    },
    saveDraft() {
      const formItem = sessionStorage.getItem("formItem");
      if (formItem) {
        const params = {
          planName: formItem.planName,
          planInfo: formItem,
          devInfo: JSON.stringify(this.cacheData()),
          draftId: sessionStorage.getItem("draftId") || ""
        };
        api.postApi_header("/draft/plan/save", "", params).then(res => {
          const { code, data } = res.data;
          if (code === 200) {
            sessionStorage.setItem("draftId", data);
            this.$message.success("存为草稿成功");
            setTimeout(() => this.$router.push("/channelAdPlan"), 300);
          }
        });
      }
    },
    cacheData() {
      this.modelInfoList = [];
      let materialIds = JSON.parse(sessionStorage.getItem("materialIds")),
        res = [];
      for (let data of this.selectedList || []) {
        let a = {
          adSize: data.size,
          materialSize: {
            w: data.size.split("*")[0],
            h: data.size.split("*")[1]
          },
          model: data.deviceModelText,
          modelID: data.deviceModel,
          regionDirections: []
        };
        let b = {
          regionCode: data.id,
          regionDesc:
            (data.provinceName || "") +
            "-" +
            (data.cityName || "") +
            "-" +
            (data.areaName || "") +
            "-" +
            (data.communityName || "") +
            "-" +
            (data.deviceName || ""),
          regionDevNum: 1,
          regionLevel: 5,
          regionValue: data.mac
        };
        if (materialIds && materialIds[data.id]) {
          a.materialId = materialIds[data.id];
          b.materialId = materialIds[data.id];
        }
        a.regionDirections.push(b);
        res.push(a);
      }
      //去重
      this.modelInfoList = this.mergeSameData(res);
      let list = JSON.stringify(this.modelInfoList);
      let selectedInfo = {
        provinceActive: this.provinceActive,
        cityActive: this.cityActive,
        areaActive: this.areaActive,
        machineActive: this.machineActive,
        buildTypeActive: this.buildTypeActive,
        yearsActive: this.yearsActive,
        excludeActive: this.excludeActive,
        houseNumMin: this.houseNumMin,
        houseNumMax: this.houseNumMax,
        buildPriceMin: this.buildPriceMin,
        buildPriceMax: this.buildPriceMax,
        personMin: this.personMin,
        personMax: this.personMax,
        tags: this.tags,
        tagIds: this.tagIds,
        tabsValue: this.tabsValue
      };
      if (this.selectedList.length != 0) {
        //找到这个数组里的数据，拼接字段
        this.selectedList.forEach(item => {
          if (item.areaString == "--") {
            item.areaString = item.province + "-" + item.city + "-" + item.area;
          }
        });
      }
      //防止点位过多，出现问题
      try {
        this.$localForage.setItem("selectedList", this.selectedList);
        // sessionStorage.setItem("selectedList", JSON.stringify(this.selectedList));
      } catch (error) {
        // sessionStorage.setItem("selectedList", JSON.stringify(this.selectedList));
        console.log("error: ", error);
      }
      sessionStorage.setItem(
        "areaDataListRow",
        JSON.stringify(this.areaDataListRow)
      );
      sessionStorage.setItem("selectedInfo", JSON.stringify(selectedInfo));
      sessionStorage.setItem("modelInfoList", list);
      sessionStorage.setItem("targetSetType", "createing");
      //储存vuex中的数据
      const framesData = {
        framesList: this.framesList,
        currentAdMaterialDetail: this.currentAdMaterialDetail,
        framesTagColor: this.framesTagColor,
        totalPlayDateNum: this.totalPlayDateNum,
        selectDateList: this.selectDateList,
        playDateNum: this.playDateNum,
        isUpload: this.isUpload
      };
      const devInfo = {
        selectedList: this.selectedList,
        areaDataListRow: this.areaDataListRow,
        selectedInfo,
        modelInfoList: list,
        conditionList: sessionStorage.getItem("conditionList"),
        framesData
      };
      return devInfo;
    },
    // 获取销售收入
    gainSaleIncome() {
      const devIds = this.selectedList.map(item => item.id).join(",");
      let params = this.valiateAdMachineShareData;
      params = {
        devIds: devIds,
        userId: params.userId,
        beginTime: params.beginTime,
        endTime: params.endTime,
        playDuration: params.playDuration,
        playTimes: params.playTimes,
        spaceId: params.spaceId,
        priceStrategy: 1,
        deliveryPeriod: this.deliveryPeriod
      };
      return new Promise(resolve => {
        api
          .postApi(`/select/getAdPlanPrice`, params)
          .then(res => {
            this.tableDataSaleIncome = [];
            const { data, code } = res.data;
            if (code === 200 && data) {
              let temp = {};
              temp.key = 0;
              temp.price = data.price;
              temp.demand = `${params.playDuration}秒/${params.playTimes}次`;
              temp.count = [
                "核心：" + data.coreCityCnt,
                "重点：" + data.keyCityCnt,
                "普通：" + data.otherCityCnt
              ];
              temp.date = `${params.beginTime}-${params.endTime}`;
              // temp.income = data.price || '';
              this.tableDataSaleIncome.push(temp);
              this.income = data.price;
              this.saleIncomeModal = true;
              resolve(false);
            } else {
              resolve(true);
            }
          })
          .catch(() => resolve(true))
          .finally(() => {
            this.saleIncomeModal = true;
          });
      });
    },
    // 确认销售收入后调用
    handleSaleIncome() {
      if (!this.income) {
        this.$message.error("请确认销售收入！");

        return;
      }
      this.saleIncomeModal = false;
      this.cacheData();
      this.formItem = JSON.parse(sessionStorage.getItem("formItem"));
      this.$set(this.formItem, "price", this.income);
      setTimeout(() => {
        this.$router.push("./channelMaterialSet");
      }, 100);
    },
    //下一步
    async nextStep() {
      this.valiateLoading = true;
      if (this.$refs.choosePoint.checkDate()) {
        this.valiateLoading = false;
        return;
      }
      this.modelInfoList = [];
      if (this.selectedList.length > 0) {
        if (this.formItem.priceStrategy == 1) {
          // 轮播
          await this.$refs.discontentModal
            .valiateAdMachineShare()
            .then(data => {
              this.valiateLoading = false;
              // 点位校验不通过
              if (data === false) return;
              // 轮播广告,获取销售收入
              this.gainSaleIncome();
            })
            .finally(() => {
              this.valiateLoading = false;
            });
        } else if (this.formItem.priceStrategy == 2) {
          // 精准，不进行点位校验
          this.cacheData();
          this.valiateLoading = false;
          setTimeout(() => {
            this.$router.push("./channelMaterialSet");
          }, 100);
        }
        /* if (this.formItem.priceStrategy == 1) {
          // 轮播广告,获取销售收入
          this.gainSaleIncome();
        } else {
          this.cacheData();
          setTimeout(() => {
            this.$router.push('./channelMaterialSet');
          }, 100);
        } */
      } else {
        this.$message.error("请选择点位！");
        this.valiateLoading = false;
      }
    },
    //合并相同id的数据
    mergeSameData(arr) {
      let hash = {};
      let i = 0;
      let res = []; //结果数组
      arr.forEach(function(item) {
        var modelID = item.modelID;
        hash[modelID]
          ? //有相同的modelID的对象,把regionDirections合并到第一个对象里
            (res[hash[modelID] - 1].regionDirections = res[
              hash[modelID] - 1
            ].regionDirections.concat(item.regionDirections))
          : //没有相同的modelID
            (hash[modelID] =
              ++i &&
              res.push({
                adSize: item.adSize,
                materialSize: item.materialSize,
                materialId: item.materialId,
                model: item.model,
                modelID: item.modelID,
                regionDirections: item.regionDirections
              }));
      });
      return res;
    },
    //获取标签
    getTagsTree() {
      api.getApi("/tags/tree").then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.tagsTree = [data];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    /**
     *
     * @param {*} selectList 选择的标签id集合
     * @param {*} selectObjList 选择的标签对象集合
     * @param {*} type 是否需要请求接口
     */
    changeTags(selectList, selectObjList, type) {
      if (this.tags.length > 0) {
        let tags = [];
        this.tags.forEach(i => {
          if (i.type && i.type != "tag") {
            tags.push(i);
          }
        });
        this.tags = tags;
      }

      if (selectObjList.length > 0) {
        selectObjList.forEach(item => {
          this.tags.push({
            id: item.id,
            name: `标签:${item.name}`,
            type: "tag"
          });
        });
        this.tagIds = selectList;
        if (type) {
          this.current = 1;
          this.getAreaDataList(1);
        }
      } else if (this.tagIds.length > 0) {
        //如果是删减到最后一个的时候
        this.tagIds = selectList;
        if (type) {
          this.current = 1;
          this.getAreaDataList(1);
        }
      }
    }
  }
};
</script>
<style lang="scss">
.m-targetSet {
  position: relative;
  .u-modle-p {
    width: 100%;
    height: 42px;
    background: rgba(240, 242, 245, 0.41);
    font-size: 18px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 42px;
    padding-left: 24px;
    margin-bottom: 32px;
  }
  /deep/.ant-table-thead > tr,
  /deep/ .ant-table-tbody > tr {
    height: 60px;
  }

  /deep/ .ant-table-thead > tr > th,
  /deep/ .ant-table-tbody > tr > td {
    padding: 0px 16px !important;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 0 16px;
  }
  .m-change-number {
    height: 40px;
    margin-bottom: 16px;

    .m-all-number {
      width: 560px;
      height: 40px;
      background: rgba(230, 247, 255, 1);
      border-radius: 4px;
      border: 1px solid rgba(145, 213, 255, 1);
      padding-left: 16px;
      line-height: 40px;

      i {
        color: #1890ff;
        margin-right: 8px;
      }

      em {
        color: #0090ff;
      }

      .u-clear {
        display: block;
        float: right;
        margin-right: 16px;
        color: #0090ff;
        cursor: pointer;
      }
    }
  }

  .m-foot-btn {
    width: 100%;
    padding: 32px 0 0 0;
    text-align: center;
    .u-nextStep-btn {
      width: auto;
      min-width: 76px;
      margin-left: 8px;
      margin-right: 8px;
    }
    .u-save-btn {
      margin-right: 8px;
    }
    .ant-badge-count {
      background: #ff5c5c;
    }
  }
}
.spin-target {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding-top: 50%;
  background: rgba(0, 0, 0, 0.05);
  z-index: 1000;
}
.ant-select-tree li span.ant-select-tree-checkbox {
  margin: 5px 4px 0 0;
  float: right;
}

.ant-form-item-control-wrapper {
  width: auto;
}

.ant-select-dropdown {
  /*height: 230px;*/

  .ant-select-not-found {
    margin-top: 60px;
  }
}

.option-wrap {
  /*width: 790px;*/
  /*margin: 0 auto 50px;*/
  margin-bottom: 50px;
  margin-left: 24px;
  color: rgba(0, 0, 0, 0.85);
}

/*机型选择*/
.type_select {
  margin-bottom: 32px;

  > p {
    text-align: center;
    line-height: 28px;
    margin-bottom: 16px;
  }

  .box {
    min-width: 880px;
    max-width: 1050px;
    margin: 0 auto;
    overflow-x: auto;

    .type_warp {
      min-width: 880px;
      padding-bottom: 16px;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .type_box {
        width: 260px;
        height: 480px;
        padding-top: 24px;
        background: rgba(249, 250, 251, 1);
        text-align: center;
        position: relative;
        margin-right: 32px;

        .type_number {
          width: 100%;
          position: absolute;
          top: 140px;
          left: 0;
          cursor: pointer;
          z-index: 10;
        }

        > img {
          width: 202px;
          cursor: pointer;
        }

        .type_info {
          margin-top: 16px;
          color: rgba(0, 0, 0, 0.65);

          p {
            font-size: 12px;
          }
        }
      }

      .type_box:nth-last-child(1) {
        margin-right: 0;
      }
    }
  }
}

/*投放区域信息填选*/
.model_info {
  /*width: 85%;*/
  width: 870px;
  margin: 0 auto 24px;
  border-radius: 4px;
  border: 1px solid rgba(216, 216, 216, 1);

  header {
    text-align: left;
    height: 54px;
    line-height: 54px;
    background: rgba(250, 250, 250, 1);
    border-bottom: 1px solid rgba(216, 216, 216, 1);
    position: relative;
    padding: 0 16px;
    border-radius: 4px 4px 0 0;

    b {
      margin-right: 12px;
    }

    .header_del {
      position: absolute;
      right: 16px;
      top: 0;
      color: rgba(24, 144, 255, 1);
      cursor: pointer;
    }
  }

  .model_info_body {
    padding: 24px;
    display: flex;

    .model_left {
      width: 148px;
      height: 282px;
      background: url("../../../static/image/type.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 200px;
      color: rgba(24, 144, 255, 1);
    }

    .model_right {
      flex: 1;
      margin-left: 24px;

      .info_box {
        height: 32px;
        background: rgba(230, 247, 255, 1);
        border-radius: 4px;
        border: 1px solid rgba(145, 213, 255, 1);
        line-height: 32px;
        padding: 0 16px;
        position: relative;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        margin-bottom: 8px;
        position: relative;

        span {
          color: rgba(24, 144, 255, 1);
        }

        .info_clear {
          position: absolute;
          right: 16px;
          cursor: pointer;
        }
      }

      .select_info {
        border: 1px solid rgba(216, 216, 216, 1);
        min-height: 202px;
        overflow-y: auto;
        margin-top: 8px;
        border-radius: 4px;
        position: relative;

        .select_info_ul {
          li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid rgba(216, 216, 216, 1);
            padding: 0 16px;

            .color_span {
              color: rgba(24, 144, 255, 1);
            }

            .li_input_number {
              margin: 0 4px 0 16px;
            }

            i.minus {
              color: #de2c2c;
              cursor: pointer;
              margin-left: 4px;

              svg {
                font-size: 16px;
              }
            }
          }
        }

        .no_data {
          /*margin: auto 0;*/
          width: 100%;
          text-align: center;
          position: absolute;
          top: 13%;
        }
      }
    }
  }
}

/*新增媒体*/
.add_model_info_btn {
  /*width: 85%;*/
  width: 870px;
  margin: 0 auto 24px;
  box-sizing: border-box;
  height: 32px;
  border: 1px dashed rgba(24, 144, 255, 1);
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
  font-size: 14px;
  color: rgba(24, 144, 255, 1);
}

/*新增机型*/
.select_model_warp {
  width: 100%;
  overflow-x: auto;

  .select_model_ul {
    display: flex;
    justify-content: space-around;
    overflow-x: auto;
    /*margin-bottom: 16px;*/
    margin: 0 auto 16px;

    li {
      width: 196px;
      height: 411px;
      border: 1px solid rgba(216, 216, 216, 1);
      margin-left: 32px;
      border-radius: 4px;

      header {
        text-align: left;
        height: 40px;
        line-height: 40px;
        background: rgba(250, 250, 250, 1);
        padding: 0 16px;
        border-bottom: 1px solid rgba(216, 216, 216, 1);
        border-radius: 4px 4px 0 0;

        .ant-checkbox-inner {
          border-radius: 50%;
        }
      }

      .model_li_body {
        .model_li_img {
          padding: 16px;
          position: relative;

          img {
            width: 100%;
            height: 282px;
          }

          > p {
            position: absolute;
            top: 34%;
            left: 34%;
            color: rgba(24, 144, 255, 1);
          }
        }

        .model_size {
          text-align: center;
          color: rgba(0, 0, 0, 0.65);

          p {
            font-size: 12px;
          }
        }
      }

      .disabled_type {
        opacity: 0.6;
      }
    }

    li:nth-child(1) {
      margin-left: 0;
    }
  }
}

/*区域范围*/
.select-wrap {
  position: relative;
  padding-bottom: 48px;
  margin-bottom: 32px;
  .select-box {
    border: 1px solid rgba(224, 224, 224, 1);
    padding: 0 16px 12px;

    .row {
      display: flex;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
      /*height: 48px;*/
      /*align-items: center;*/
      padding: 12px 0 0;
      font-size: 14px;
      position: relative;
      box-sizing: border-box;
      transition: all 0.3s ease;
      overflow: hidden;

      .title {
        width: 48px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
      .lineOn {
        width: auto;
      }
      .option-ul {
        display: flex;
        flex-wrap: wrap;
        width: 90%;
        /*align-items: center;*/
        /*height: 26px;*/

        li {
          box-sizing: border-box;
          padding: 3px 12px;
          text-align: center;
          cursor: pointer;
          color: rgba(0, 0, 0, 0.65);
          margin-bottom: 12px;
        }

        li.active {
          background: rgba(24, 144, 255, 1);
          border-radius: 2px;
          color: #fff;
        }
      }

      p {
        width: 56px;
        height: 24px;
        background: rgba(240, 240, 240, 1);
        border-radius: 2px;
        font-size: 12px;
        text-align: center;
        line-height: 24px;
        cursor: pointer;
        color: rgba(0, 0, 0, 0.45);
        position: absolute;
        right: 0;

        .anticon svg {
          font-size: 12px;
          color: rgba(0, 0, 0, 0.45);
          margin-left: 2px;
        }
      }

      em {
        width: 76px;
        height: 26px;
        display: inline-block;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(194, 194, 194, 1);
        color: rgba(0, 0, 0, 0.35);
        text-align: center;
        line-height: 26px;
      }
    }

    .row:last-child {
      border-bottom: none;
    }

    .other {
      .other-select-menu {
        display: inline-block;
        width: 76px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        border: 1px solid #c2c2c2;
        color: rgba(0, 0, 0, 0.35);
        position: relative;
        cursor: pointer;
        margin-right: 12px;
      }

      .other-select-menu.active {
        border: 1px solid #1890ff;
        color: #1890ff;
      }

      .other-select-menu::before,
      .other-select-menu.active::before {
        display: inline-block;
        content: "";
        width: 0;
        height: 0;
        border: 4px solid transparent;
        border-bottom-color: rgba(0, 0, 0, 0.35);
        border-right-color: rgba(0, 0, 0, 0.35);
        position: absolute;
        right: 1px;
        bottom: 1px;
        z-index: 10;
      }

      .other-select-menu.active::before {
        border-bottom-color: #1890ff;
        border-right-color: #1890ff;
      }
    }

    .multiple-cascder {
      position: absolute;
      top: 10px;
      left: 54px;
      height: 26px;
      width: 64px;
      .ant-select {
        width: 100% !important;
        opacity: 0;
        .ant-select-selection,
        .ant-select-search__field,
        .ant-select-selection__choice {
          cursor: pointer;
        }
      }
    }
  }

  .tags-box {
    width: 100%;
    background: rgba(241, 241, 241, 1);
    padding: 6px 16px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    position: relative;
    flex-wrap: wrap;

    .tag {
      color: rgba(0, 0, 0, 0.35);
      padding: 2px 8px;
      font-size: 14px;
      background: rgba(255, 255, 255, 1);
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.1);
      margin-right: 8px;
      margin-bottom: 4px;
    }

    .tag:hover {
      color: #1890ff;
      border-color: #1890ff;

      .anticon-close {
        color: #1890ff;
      }
    }

    .all-clear {
      position: absolute;
      right: 16px;
      color: #1890ff;
      cursor: pointer;
    }
  }

  .tip-box,
  .table-box {
    margin-top: 8px;
  }

  .content-line {
    display: flex;
    .action-line {
      display: flex;
      align-items: center;
      margin: 0 0 0 auto;
    }
  }

  .page-wrap {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

.tip-box .ant-alert-message {
  span {
    color: #1890ff;
    cursor: pointer;
  }
}

.other-pop {
  .ant-popover-placement-bottomLeft
    > .ant-popover-content
    > .ant-popover-arrow {
    display: none;
  }

  .ant-popover-inner {
    position: relative;
    top: -6px;
  }

  .ant-popover-inner-content {
    padding: 0;
  }

  .range-input {
    padding: 8px;

    .inputs {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      .ant-input {
        width: 64px;
        height: 26px;
      }

      span {
        margin: 0px 4px;
      }
    }

    .btns {
      display: flex;
      justify-content: space-between;
      align-items: center;

      button {
        width: 64px;
        height: 26px;
      }
    }
  }
}

/*滚动条*/
.tag-ul {
  padding: 4px 0;
  width: 100px;
  max-height: 180px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.tag-ul::-webkit-scrollbar {
  width: 4px;
  background: #fff;
}

.tag-ul::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #d8d8d8;
  border-radius: 4px;
}

.tag-li {
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  text-align: center;
}

.tag-li:hover {
  background: #e6f7ff;
}

.tag-li.active {
  color: #1890ff;
}

/*查看型号*/
.model-tabs {
  height: 550px;
  border: 1px solid rgba(233, 233, 233, 1);

  .ant-tabs-nav-wrap {
    padding: 8px;
    box-sizing: border-box;
  }

  .ant-tabs-tab-active {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    color: rgba(0, 0, 0, 0.85);
  }

  .ant-tabs-tab {
    width: 272px;
    height: 56px;
    line-height: 40px;
    padding: 22px 20px;
    box-sizing: border-box;
    margin-bottom: 0;
    font-size: 20px;
  }

  .ant-tabs-left-bar .ant-tabs-tab {
    text-align: left;
  }

  .ant-tabs-ink-bar {
    display: none !important;
  }

  .ant-tabs-tabpane {
    text-align: center;
    padding: 18px 0;
    box-sizing: border-box;
  }
}

/*已选点位*/
.selected-wrap {
  /deep/.ant-table-thead > tr,
  /deep/ .ant-table-tbody > tr {
    height: 46px;
  }

  .ant-table-thead > tr > th,
  /deep/ .ant-table-tbody > tr > td {
    padding: 0px 8px !important;
  }
  /deep/ .ant-table-thead > tr > th {
    padding: 0 8px;
  }
  position: relative;

  .delect-btn {
    position: absolute;
    left: 0;
    bottom: 15px;
  }
}

.del_card {
  i {
    svg {
      font-size: 17px;
    }
  }

  .ant-popover-message-title {
    margin-bottom: 12px;

    h3 {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
      margin-bottom: 12px;
    }
  }
}

/*一键选点*/
.fast-model {
  .inputs {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    > div {
      display: flex;
      justify-content: center;

      .ant-select {
        width: 99px !important;
      }

      .ant-select:first-child {
        .ant-select-selection--single {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
      }

      .ant-select:nth-child(2) {
        .ant-select-selection--single {
          border-radius: 0;
          border-left: none;
          border-right: none;
        }
      }

      .ant-select-selection-selected-value {
        padding-right: 0;
      }

      input {
        border-top-left-radius: 0px;
        border-bottom-left-radius: 0px;
      }
    }
    .error-fast-count-input {
      border: 1px solid rgba(255, 0, 0, 0.65);
    }
  }

  > p {
    color: rgba(255, 0, 0, 0.65);
    margin-top: 2px;
  }
}

.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
/* 表格滚动条 */
.table-box ::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
}
</style>
